export interface SignedAuthorizationSelection {
  signedBlobId: string;
  templateId: string;
  updatedAt: number;
}

const STORAGE_PREFIX = 'hipaa_signed_authorization_selection';

const getStorageKey = (matterId: string) => `${STORAGE_PREFIX}:${matterId}`;

const isBrowser = () => typeof window !== 'undefined';

export const getSignedAuthorizationSelection = (
  matterId: string | undefined,
): SignedAuthorizationSelection | null => {
  if (!matterId || !isBrowser()) return null;
  try {
    const raw = window.localStorage.getItem(getStorageKey(matterId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as SignedAuthorizationSelection | null;
    if (!parsed?.signedBlobId || !parsed?.templateId) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};

export const setSignedAuthorizationSelection = (
  matterId: string | undefined,
  selection: { signedBlobId: string; templateId: string },
) => {
  if (!matterId || !isBrowser()) return;
  try {
    const payload: SignedAuthorizationSelection = {
      ...selection,
      updatedAt: Date.now(),
    };
    window.localStorage.setItem(
      getStorageKey(matterId),
      JSON.stringify(payload),
    );
  } catch {
    // ignore write errors (e.g., private mode)
  }
};

export const clearSignedAuthorizationSelection = (
  matterId: string | undefined,
) => {
  if (!matterId || !isBrowser()) return;
  try {
    window.localStorage.removeItem(getStorageKey(matterId));
  } catch {
    // ignore
  }
};
